import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';
import bank from './bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from './component/btn/btn';
import List from './component/list/list';
import TreeList from './component/list/treeList';

import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from './component/search/search';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { changeNum } from './common/function';

function IntegrateAgent() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const MyData = useSelector((state) => state.MyData);

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    // 트리 전체 (지사/총판/대리점)
    const [listData, setListData] = useState([]);
    // 검색/토글/접기/펴기로 현재 화면에 표시 중인 트리
    const [filterTreeData, setFilterTreeData] = useState([]);
    // 테이블에 표시할 flatten(1차원) 배열
    const [combineData, setCombineData] = useState([]);
    // 총 에이전트 수
    const [agentLength, setAgentLength] = useState(0);

    // 매출 100% 기준 (1단계 중 최댓값)
    const [maxRootSales, setMaxRootSales] = useState(0);

    // 모달
    const [createModal, setCreateModal] = useState(false);
    const [updateModal, setUpdataeModal] = useState(false);
    const [clickData, setClickData] = useState(null);

    // 날짜
    const inputRef = useRef(null);
    const pickerRef = useRef(null);
    const [preDate, setPreDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [nextDate, setNextDate] = useState(dayjs().format("YYYY-MM-DD"));

    // 검색
    const select3 = ["에이전트명", "에이전트아이디"];
    const [selectedValue2, setSelectedValue2] = useState("에이전트명");
    const [selectedText4, setSelectText4] = useState("");

    // 리렌더 트리거
    const [reload, setReload] = useState(false);
    const [listState, setListState] = useState(false);

    const [sortAmt, setSortAmt] = useState(0);

    // ─────────────────────────────────────────────────────────
    // 1) 초기 설정: 헤더 & 날짜피커
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        dispatch(change_Current_Location("통합에이전트"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "에이전트관리",
                subTitle: "통합에이전트",
            })
        );

        // Litepicker
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false,
            format: "YYYY-MM-DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                picker.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY-MM-DD"));
                    setNextDate(end.format("YYYY-MM-DD"));
                });
            },
        });

        setDateRange(dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD"));
        setTimeout(() => setLoading(false), 500);

        return () => {
            pickerRef.current?.destroy();
        };
    }, []);

    const setDateRange = (start, end) => {
        setPreDate(start);
        setNextDate(end);
        pickerRef.current?.setDateRange(start, end);
        onSubmitSearch();
    };

    // ─────────────────────────────────────────────────────────
    // 2) 검색 버튼
    // ─────────────────────────────────────────────────────────
    const onSubmitSearch = () => {
        setReload((prev) => !prev);
        setClickData(null);
    };

    // ─────────────────────────────────────────────────────────
    // 3) 서버에서 트리 데이터 가져오기 (전체)
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        fetchAgentData();
    }, [reload]);

    const fetchAgentData = async () => {
        try {
            setLoading(true);
            const res = await axios.get(process.env.REACT_APP_API + "/api/agent", {
                withCredentials: true,
            });
            console.log(res.data);

            if (res.data?.code < 2000) {
                const data = res.data?.data?.newAgent ?? [];
                // 1) 트리 기본 구조 초기화
                const init = initTreeData(data, 1, null);

                // 2) 3단계 노드에 대해서 4, 5, 6단계를 목업으로 추가
                // addMockChildren(init);

                // 3) 매출(sales) 값 할당 (최하위는 랜덤, 상위는 합계)
                // assignSales(init);

                // 4) 1단계 노드 중 최댓값 찾기
                const maxRoot = getMaxRootSales(init);
                setMaxRootSales(maxRoot);

                // 5) 스테이트 반영
                setListData(init);
                setAgentLength(res.data?.data?.count ?? 0);
            } else if (res.data?.code === 9999) {
                navigate("/");
            }
        } catch (err) {
            console.error(err);
            navigate("/");
        } finally {
            setLoading(false);
        }
    };

    // (A) parent 참조 + 레벨정보 세팅
    function initTreeData(arr, level, parent) {
        return arr.map((item) => {
            const newItem = {
                ...item,
                _expanded: false,
                _level: level,
                parent: parent || null,
            };
            if (item.children && item.children.length > 0) {
                newItem.children = initTreeData(item.children, level + 1, newItem);
            } else {
                newItem.children = [];
            }
            return newItem;
        });
    }

    // (B) 3단계 노드에 4~6단계 mock children 추가
    function addMockChildren(nodes) {
        nodes.forEach((node) => {
            if (node._level === 3) {
                const child4 = {
                    id: node.id + "-4",
                    nm: node.nm + "_4단계",
                    agent_id: (node.agent_id ?? "") + "_4",
                    _expanded: false,
                    _level: 4,
                    parent: node,
                    children: [],
                };
                const child5 = {
                    id: node.id + "-5",
                    nm: node.nm + "_5단계",
                    agent_id: (node.agent_id ?? "") + "_5",
                    _expanded: false,
                    _level: 5,
                    parent: child4,
                    children: [],
                };
                const child6 = {
                    id: node.id + "-6",
                    nm: node.nm + "_6단계",
                    agent_id: (node.agent_id ?? "") + "_6",
                    _expanded: false,
                    _level: 6,
                    parent: child5,
                    children: [],
                };
                child4.children.push(child5);
                child5.children.push(child6);

                node.children = [...(node.children || []), child4];
            }

            if (node.children && node.children.length > 0) {
                addMockChildren(node.children);
            }
        });
    }

    // (C) 매출 할당: 최하위 노드는 랜덤, 상위 노드는 하위 합
    function assignSales(nodes) {
        // post-order 순회
        nodes.forEach((node) => {
            if (node.children && node.children.length > 0) {
                // 자식 있으면, 자식 먼저 재귀
                assignSales(node.children);
                // 자식들의 매출 합
                node.sales = node.children.reduce((sum, c) => sum + (c.sales || 0), 0);
            } else {
                // 최하위(leaf) 노드 → 랜덤(10만 ~ 100만)
                const min = 100000;
                const max = 1000000; // 100만
                node.sales = Math.floor(Math.random() * (max - min + 1)) + min;
            }
        });
    }

    // (D) 1단계 노드 중 가장 큰 매출 찾기
    function getMaxRootSales(nodes) {
        let maxSales = 0;
        for (const node of nodes) {
            if (node._level === 1) {
                if ((node.trx_amt || 0) > maxSales) {
                    maxSales = node.trx_amt;
                }
            }
            // 재귀로 더 깊이 내려갈 필요는 없지만, 혹시 1단계만 있는 게 아닐 수도 있으므로
            if (node.children && node.children.length > 0) {
                const childMax = getMaxRootSales(node.children);
                if (childMax > maxSales) {
                    maxSales = childMax;
                }
            }
        }
        return maxSales;
    }

    // ─────────────────────────────────────────────────────────
    // 4) 검색 로직 (부모+자식)
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        const keyword = selectedText4.trim();

        if (!keyword) {
            // 검색어 없으면 => 모두 접기
            const closedAll = closeAllExpanded(listData);
            setFilterTreeData(closedAll);
            return;
        }

        const allNodes = [];
        flattenTreeAll(listData, allNodes);

        const matchedSet = new Set();
        for (const node of allNodes) {
            const nmMatch =
                node.nm && node.nm.toLowerCase().includes(keyword.toLowerCase());
            const idMatch =
                node.agent_id &&
                node.agent_id.toLowerCase().includes(keyword.toLowerCase());
            if (nmMatch || idMatch) {
                addAncestors(node, matchedSet);
                addDescendants(node, matchedSet);
            }
        }

        const filteredTree = keepNodeAndAllChildren(listData, matchedSet);
        const openedAll = openAllExpanded(filteredTree); // 검색 시 모두 펼침
        setFilterTreeData(openedAll);
    }, [listData, selectedText4]);

    function flattenTreeAll(nodes, output) {
        for (const node of nodes) {
            output.push(node);
            if (node.children && node.children.length) {
                flattenTreeAll(node.children, output);
            }
        }
    }
    function addAncestors(node, matchedSet) {
        let cur = node;
        while (cur) {
            matchedSet.add(cur);
            cur = cur.parent;
        }
    }
    function addDescendants(node, matchedSet) {
        matchedSet.add(node);
        if (!node.children || node.children.length === 0) return;
        for (const c of node.children) {
            addDescendants(c, matchedSet);
        }
    }
    function keepNodeAndAllChildren(originalNodes, matchedSet) {
        const result = [];
        for (const node of originalNodes) {
            if (matchedSet.has(node)) {
                const newNode = { ...node };
                newNode.children = keepNodeAndAllChildren(node.children, matchedSet);
                result.push(newNode);
            } else {
                const filteredChildren = keepNodeAndAllChildren(node.children, matchedSet);
                if (filteredChildren.length > 0) {
                    const newNode = { ...node };
                    newNode.children = filteredChildren;
                    result.push(newNode);
                }
            }
        }
        return result;
    }

    // ─────────────────────────────────────────────────────────
    // filterTreeData가 바뀔 때마다 flatten → combineData
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        if (!filterTreeData || filterTreeData.length === 0) {
            setCombineData([]);
            return;
        }

        // 1) 트리 정렬
        function sortTreeByAmt(nodes) {
            if (!Array.isArray(nodes)) return [];
            const arr = [...nodes];
            if (sortAmt === 1) {
                arr.sort((a, b) => (b.trx_amt || 0) - (a.trx_amt || 0));
            } else if (sortAmt === 2) {
                arr.sort((a, b) => (a.trx_amt || 0) - (b.trx_amt || 0));
            }
            return arr.map(node => ({
                ...node,
                children: sortTreeByAmt(node.children)
            }));
        }

        const treeToFlatten =
            (sortAmt === 1 || sortAmt === 2)
                ? sortTreeByAmt(filterTreeData)  // filterTreeData 를 정렬
                : filterTreeData;

        // 2) 플랫하게 펼치기
        const flat = [];
        flattenTree(treeToFlatten, flat);

        // 3) 테이블 빌드
        setCombineData(buildTableRowArray(flat));
    }, [filterTreeData, sortAmt]);

    // 펼쳐진 노드만 flatten
    function flattenTree(nodes, output, ancestors = []) {
        nodes.forEach((node, idx) => {
            const isLastChild = idx === nodes.length - 1;
            node._ancestorLastChild = ancestors;
            node._isLastChild = isLastChild;

            output.push(node);

            if (node._expanded && node.children && node.children.length) {
                flattenTree(node.children, output, [...ancestors, isLastChild]);
            }
        });
    }

    // (E) 아이콘 클릭 → 하위 펼침/접기
    function handleIconClick(e, node) {
        e.stopPropagation(); // 행 클릭과 구분
        setFilterTreeData((prev) => toggleExpandedInTree(prev, node.id));
    }

    // (F) 테이블 바디(각 행) 구성
    function buildTableRowArray(flatData) {
        let tableBodyData = [];

        for (let i = 0; i < flatData.length; i++) {
            const node = flatData[i];

            // 1) 세로줄 아이콘 구성
            const depthLines = (node._ancestorLastChild ?? []).map((isAncestorLast) =>
                isAncestorLast
                    ? "/img/icon/ftv2blank.gif"
                    : "/img/icon/ftv2vertline.gif"
            );

            let iconSrc = "/img/icon/ftv2node.gif";
            if (node.children && node.children.length > 0) {
                if (node._expanded) {
                    iconSrc = node._isLastChild
                        ? "/img/icon/ftv2plastmnode.png"
                        : "/img/icon/ftv2mnode.gif";
                } else {
                    iconSrc = node._isLastChild
                        ? "/img/icon/ftv2plastnode.gif"
                        : "/img/icon/ftv2pnode.gif";
                }
            } else {
                iconSrc = node._isLastChild
                    ? "/img/icon/ftv2lastnode.gif"
                    : "/img/icon/ftv2node.gif";
            }

            depthLines.push(iconSrc);

            // 클릭 가능한 아이콘
            const iconElements = depthLines.map((src, idx) => {
                const isLastIcon = idx === depthLines.length - 1;
                if (isLastIcon && node.children && node.children.length > 0) {
                    return (
                        <img
                            key={idx}
                            src={src}
                            alt=""
                            style={{ height: "28px", boxShadow: "none", cursor: "pointer" }}
                            onClick={(e) => handleIconClick(e, node)}
                        />
                    );
                } else {
                    return (
                        <img
                            key={idx}
                            src={src}
                            alt=""
                            style={{ height: "28px", boxShadow: "none" }}
                        />
                    );
                }
            });

            // 2) 에이전트명 셀
            const agentNameCell = (
                <div
                    style={{
                        position: "absolute",
                        top: "50%",
                        transform: "translateY(-50%)",
                        left: "10px",
                        height: "100%",
                        display: "flex",
                    }}
                >
                    {iconElements}
                    <div style={{ display: "flex", alignItems: "center", paddingLeft: "3px" }}>
                        {node.nm}
                        {node?.children?.length > 0 ? `(${node?.children?.length})` : ""}
                    </div>
                </div>
            );

            const agentMID = (
                <div
                    style={{
                        position: "absolute",
                        top: "50%",
                        transform: "translateY(-50%)",
                        left: "10px",
                        height: "100%",
                        display: "flex",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {node?.agent_id}
                    </div>
                </div>
            );

            // 3) 매출 백분율 막대 표시 (오른쪽 정렬)
            const salesValue = node.trx_amt || 0;
            const ratio = maxRootSales > 0 ? (salesValue / maxRootSales) : 0;
            const ratioPercent = (ratio * 100).toFixed(1) + "%"; // 예시로 소수점 1자리

            // 숫자 표시(예: 123,456)
            const salesFormatted = salesValue.toLocaleString();

            // ★ 배경 막대를 오른쪽 정렬로 깔기
            const salesCell = (
                <div style={{ position: "absolute", width: "100%", height: "100%", right: "0px", top: "0px" }}>
                    {/* 막대 (right align) */}
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            bottom: 0,
                            right: 0,
                            // width: ratioPercent,
                            // backgroundColor: "#ffd3d3",
                        }}
                    />
                    {/* 실제 숫자 */}
                    <div
                        style={{
                            position: "relative",
                            zIndex: 1,
                            textAlign: "right",
                            paddingRight: "6px",
                            height: "100%",
                            lineHeight: "28px", // 행 높이(디자인에 맞게 조절)
                            userSelect: "none",  // 더블클릭 시 파란배경 방지,
                            // color:"#000"
                        }}
                    >
                        {changeNum(Number(salesFormatted))}
                    </div>
                </div>
            );

            const salesMod = (
                <div style={{ position: "absolute", width: "100%", height: "100%", right: "0px", top: "0px" }}>
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            bottom: 0,
                            right: 0,
                        }}
                    />
                    {/* 실제 텍스트 */}
                    <div
                        style={{
                            position: "relative",
                            zIndex: 1,
                            textAlign: "center",
                            height: "100%",
                            lineHeight: "28px",
                            userSelect: "none",
                        }}
                    >
                        {node.mod_dt?.slice(2, 16) /* "2025-04-08 05:31:33" → "25-04-08 05:31" */}
                    </div>
                </div>
            );


            const rowData = [
                {
                    no: 1,
                    text: agentNameCell,
                    width: "250px",
                    textAlign: "left",
                },
                // {
                //     no: 2,
                //     text: agentMID,
                //     width: "110px",
                //     textAlign: "left",
                // },
                {
                    no: 3,
                    text: salesCell, // ← 백분율 막대 + 숫자
                    width: "90px",
                    textAlign: "right",
                },
                {
                    no: 4,
                    text: salesMod, // ← 백분율 막대 + 숫자
                    width: "100px",
                    textAlign: "center",
                },
            ];

            rowData.id = node.id;
            tableBodyData.push(rowData);
        }

        return tableBodyData;
    }

    // (G) 행 단일 클릭
    function handleRowClick(row) {
        const foundNode = findNodeById(filterTreeData, row.id);
        if (foundNode) {
            setClickData(foundNode);
            setCreateModal(false);
            setUpdataeModal(true);
        }
        setListState((e) => !e);
    }

    // (H) 행 더블 클릭 → 하위 펼침/접기
    const handleRowDoubleClick = (row) => {
        const foundNode = findNodeById(filterTreeData, row.id);
        if (foundNode && foundNode.children && foundNode.children.length > 0) {
            setFilterTreeData((prev) => toggleExpandedInTree(prev, foundNode.id));
        }
    };

    // 펼침/접기 토글
    function toggleExpandedInTree(dataArr, targetId) {
        return dataArr.map((item) => {
            if (item.id === targetId) {
                return { ...item, _expanded: !item._expanded };
            }
            if (item.children && item.children.length > 0) {
                return {
                    ...item,
                    children: toggleExpandedInTree(item.children, targetId),
                };
            }
            return { ...item };
        });
    }

    function findNodeById(dataArr, targetId) {
        for (let item of dataArr) {
            if (item.id === targetId) return item;
            if (item.children && item.children.length > 0) {
                const result = findNodeById(item.children, targetId);
                if (result) return result;
            }
        }
        return null;
    }

    // ─────────────────────────────────────────────────────────
    // 전체 펴기 / 접기
    // ─────────────────────────────────────────────────────────
    function openAllExpanded(arr) {
        return arr.map((item) => ({
            ...item,
            _expanded: true,
            children: item.children ? openAllExpanded(item.children) : [],
        }));
    }

    function closeAllExpanded(arr) {
        return arr.map((item) => ({
            ...item,
            _expanded: false,
            children: item.children ? closeAllExpanded(item.children) : [],
        }));
    }

    const handleOpenAll = () => {
        setFilterTreeData((prev) => openAllExpanded(prev));
        setListState((e) => !e);
    };

    const handleCloseAll = () => {
        setFilterTreeData((prev) => closeAllExpanded(prev));
        setListState((e) => !e);
    };

    // 테이블 헤더
    const tableHeaderData = [
        {
            no: 1,
            text: "에이전트명",
            width: "250px",
            textAlign: "center",
        },
        // {
        //     no: 2,
        //     text: "아이디",
        //     width: "110px",
        //     textAlign: "center",
        // },
        {
            no: 3,
            text: (
                <div
                    className={sortAmt === 0 ? 'table-sort' : 'table-sort sort-color'}
                    onClick={() => {
                        setSortAmt(e => (e + 1) % 3);
                    }}
                    style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px", cursor: "pointer" }}
                >
                    <span>매출</span>
                    <span>
                        <span className="index_sort-btn__eWsx8">
                            <svg width="9" height="6" viewBox="0 0 5 3" fill="none">
                                <path
                                    className={`${sortAmt === 2 ? "fill-color" : ""}`}
                                    d="M0.342163 3L3.77567 3C3.96395 3 4.11658 2.85941 4.11658 2.68599C4.11658 2.62399 4.09665 2.56339 4.05932 2.5118L2.34257 0.139848C2.23813 -0.00444984 2.02647 -0.0434422 1.86981 0.0527565C1.83236 0.0757532 1.80023 0.105353 1.77526 0.139848L0.0585074 2.5118C-0.0459313 2.6561 -0.00359917 2.85106 0.153059 2.94726C0.20906 2.98165 0.274858 3 0.342163 3Z"
                                    fill={"#999"}
                                />
                            </svg>
                            <svg width="9" height="6" viewBox="0 0 5 3" fill="none">
                                <path
                                    className={`${sortAmt === 1 ? "fill-color" : ""}`}
                                    d="M3.77442 0H0.340911C0.152631 0 0 0.140589 0 0.314014C0 0.376008 0.0199222 0.436615 0.0572559 0.488197L1.77401 2.86015C1.87845 3.00445 2.09011 3.04344 2.24677 2.94724C2.28422 2.92425 2.31635 2.89465 2.34132 2.86015L4.05807 0.488197C4.16251 0.343899 4.12018 0.148937 3.96352 0.0527385C3.90752 0.0183503 3.84172 0 3.77442 0Z"
                                    fill={"#999"}
                                />
                            </svg>
                        </span>
                    </span>
                </div>
            ),
            width: "90px",
            textAlign: "center",
        },
        {
            no: 4,
            text: "수정일",
            width: "100px",
            textAlign: "center",
        },
    ];

    let tabList = MyData?.role == "SUPER" ? ["에이전트 수정", "가맹점 목록"] : ["에이전트 상세", "가맹점 목록"]

    const [activeTab, setActiveTab] = useState(MyData?.role == "SUPER" ? "에이전트 수정" : "에이전트 상세")

    const handleClickTab = (tabName) => {
        setActiveTab(tabName);
    };

    // 최종 렌더
    return (
        <div className="content" id="contents">
            {loading && <LoadingModal />}
            <MessageModal message={message} />

            {/* 검색/필터 폼 */}
            <div className="form_filter intro-y">
                <form
                    id="tabulator-html-filter-form"
                    style={{ display: "flex", alignItems: "center" }}
                >
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                    <SearchSelectText
                        type={"검색구분"}
                        selectData={select3}
                        handleSelectChange={(e) => setSelectedValue2(e.target.value)}
                        selectedValue={selectedValue2}
                        handleSelectTextChange={(e) => setSelectText4(e.target.value)}
                        selectedText={selectedText4}
                        btnText={"검색"}
                        placeholder={"에이전트명 & 아이디"}
                        onClick={onSubmitSearch}
                        state={false}
                    />
                </form>
            </div>

            <div
                className="intro-y box intro-padding"
                style={{
                    overflowY: "auto",
                    height: "calc(100dvh - 10rem)",
                }}
            >
                <div className="div-flex-2">
                    {/* 좌측: 트리 테이블 */}
                    <div style={{ maxWidth: "440px", width: "100%" }}>
                        <div
                            className="tabulator_sorting_wrap"
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <CountAmountLeft tableBodyData={agentLength} />
                            <div style={{ display: "flex", gap: "10px" }}>
                                <button
                                    type="button"
                                    className="btn btn-primary modal_btn btn_small"
                                    onClick={handleOpenAll}
                                    style={{ height: "30px", fontSize: "12px" }}
                                >
                                    펴기
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary modal_btn btn_small"
                                    onClick={handleCloseAll}
                                    style={{ height: "30px", fontSize: "12px" }}
                                >
                                    접기
                                </button>
                            </div>
                        </div>

                        <TreeList
                            tableHeaderData={tableHeaderData}
                            tableBodyData={filterTreeData ?? []}
                            filter_tableBodyData={combineData}
                            clickData={clickData}
                            onRowClick={handleRowClick}
                            onRowDoubleClick={handleRowDoubleClick}
                            listState={listState}
                            nonePage={false}
                            height={"712px"}
                            scrollState={true}
                        />
                    </div>

                    {/* 우측: 등록/수정 모달 */}
                    <div
                        style={{
                            maxWidth: createModal ? "450px" : "450px",
                            // maxWidth: createModal ? "450px" : "900px",
                            marginTop: "49px",
                            width: "100%",
                        }}
                    >
                        {
                            !createModal && !updateModal && !clickData && (
                                <div style={{ width: "100%", height: "710px", border: "16px solid rgb(69 69 69)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", fontWeight: "bold", color: "gray" }}>
                                    에이전트를 선택해주세요
                                </div>
                            )
                        }
                        {createModal && MyData?.role === "SUPER" && (
                            <div
                                style={{
                                    backgroundColor: "#575757",
                                    padding: "16px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                        padding: "0 10px",
                                        borderBottom: "1px solid #E5E5E5",
                                        backgroundColor: "#fff",
                                    }}
                                >
                                    {["에이전트 등록"].map((tab) => (
                                        <button
                                            key={tab}
                                            className="tab-btn active"
                                            style={{
                                                padding: "12px 10px 8px",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                color: "#222",
                                                background: "transparent",
                                                border: "none",
                                                borderBottom: "3px solid #3182F6",
                                                transition: "all 0.2s ease-in-out",
                                                cursor: "pointer",
                                            }}
                                        >
                                            {tab}
                                        </button>
                                    ))}
                                </div>
                                <div style={{ padding: "0 10px", backgroundColor: "#fff" }}>
                                    <CreateInfo setMessage={setMessage} setReload={setReload} />
                                </div>
                            </div>
                        )}
                        {updateModal && clickData && (
                            <div
                                style={{
                                    backgroundColor: clickData?.id ? "rgb(69 69 69)" : "",
                                    padding: "16px",
                                    display: "flex",
                                }}
                            >
                                <div style={{
                                    // borderRight: "16px solid rgb(69 69 69)", 
                                    width: "100%"
                                }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "10px",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            padding: "0 10px",
                                            borderBottom: "1px solid #E5E5E5",
                                            backgroundColor: "#fff",
                                        }}
                                    >
                                        <div style={{ display: "flex", gap: "10px" }}>
                                            {tabList.map((tab) => (
                                                <button
                                                    key={tab}
                                                    className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                                    onClick={() => handleClickTab(tab)}
                                                    style={{
                                                        padding: "12px 10px 8px",
                                                        fontSize: "14px",
                                                        fontWeight: activeTab === tab ? "600" : "400",
                                                        color: activeTab === tab ? "#222" : "#888",
                                                        background: "transparent",
                                                        border: "none",
                                                        borderBottom: activeTab === tab ? "3px solid #3182F6" : "3px solid transparent",
                                                        transition: "all 0.2s ease-in-out",
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    {tab}
                                                </button>
                                            ))}
                                        </div>
                                        {MyData?.role === "SUPER" && (
                                            <div
                                                className="button_wrap separate"
                                                style={{ marginTop: "0px" }}
                                            >
                                                <SearchCrteateBtn
                                                    type={"신규등록"}
                                                    onClick={() => {
                                                        setUpdataeModal(false);
                                                        setCreateModal(true);
                                                        setClickData(null);
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ padding: "0 10px", backgroundColor: "#fff" }}>
                                        {(activeTab === "에이전트 수정" || activeTab === "에이전트 상세") && (
                                            <UpdateInfo
                                                setMessage={setMessage}
                                                clickData={clickData}
                                                setReload={setReload}
                                            />
                                        )}
                                        {(activeTab === "가맹점 목록") && (
                                            <SubmerchantsList
                                                setMessage={setMessage}
                                                clickData={clickData}
                                                setReload={setReload}
                                            />
                                        )}
                                    </div>
                                </div>
                                {/* <div style={{ width: "100%" }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "10px",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            padding: "0 10px",
                                            borderBottom: "1px solid #E5E5E5",
                                            backgroundColor: "#fff",
                                        }}
                                    >
                                        <button
                                            className="tab-btn active"
                                            style={{
                                                padding: "12px 10px 8px",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                color: "#222",
                                                background: "transparent",
                                                border: "none",
                                                borderBottom: "3px solid #3182F6",
                                                transition: "all 0.2s ease-in-out",
                                                cursor: "pointer",
                                            }}
                                        >
                                            가맹점 목록
                                        </button>
                                    </div>
                                    <div style={{ padding: "0 10px", backgroundColor: "#fff" }}>
                                        <SubmerchantsList
                                            setMessage={setMessage}
                                            clickData={clickData}
                                            setReload={setReload}
                                        />
                                    </div>
                                </div> */}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

function CreateInfo({ setMessage, setReload }) {
    const MyData = useSelector((state) => state.MyData);
    // 초기값(모두 빈 문자열)
    const initialFormData = {
        에이전트등급: '',
        상위에이전트: '',
        에이전트ID: '',
        에이전트명: '',
        에이전트수수료: '',
        정산은행: '',
        계좌번호: '',
        예금주: '',
        세금계산서Email: '',
        PG코드: ''
    };

    // 상태
    const [formData, setFormData] = useState(initialFormData);
    const [levelData, setLevelData] = useState([])

    useEffect(() => {
        LevelList()
    }, [formData.에이전트등급])

    const LevelList = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/agent/up-list`, {
            withCredentials: true,
            params: {
                level: Number(formData.에이전트등급)
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setLevelData(tmp?.data?.agent ?? [])
            }
            else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // 중복 클릭 방지
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            await axios.post(process.env.REACT_APP_API + "/api/agent/regist", {
                auth_cd: formData.에이전트등급,
                agent_id: formData.에이전트ID,
                nm: formData.에이전트명,
                agent_fee: formData.에이전트수수료,
                parent_code: formData.상위에이전트,
                bank_nm: formData.정산은행,
                accnt_no: formData.계좌번호,
                accnt_nm: formData.예금주,
                tax_email: formData.세금계산서Email,
                worker: 'admin',
                co_id: formData.PG코드
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data;
                if (tmp?.code < 2000) {
                    setMessage({ msg: "에이전트 등록에 성공했습니다." });
                    setReload(e => !e);
                    // 등록에 성공했다면 폼을 다시 초기화
                    setFormData(initialFormData);
                } else {
                    setMessage({ msg: tmp?.msg ?? "에이전트 등록에 실패했습니다." });
                }
            }).catch(error => {
                setMessage({ msg: "에이전트 등록에 실패했습니다." });
                console.error(error);
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    // [추가] 취소 버튼 핸들러
    const handleCancel = () => {
        setFormData(initialFormData);
    };

    return (
        <div style={{ padding: "5px" }}>
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty">
                    <div
                        style={{
                            padding: '0 0 0.5rem',
                            height: "625px",
                            overflowY: "auto",
                            fontSize: "12px",
                            display: 'flex',
                            flexDirection: "column",
                        }}
                    >
                        <div className="list-info-box">
                            <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                <ul>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>PG코드</span>
                                            <input
                                                id="PG코드"
                                                name="PG코드"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.PG코드}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>에이전트등급</span>
                                            <select
                                                id="에이전트등급"
                                                name="에이전트등급"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.에이전트등급}
                                                onChange={handleChange}
                                            >
                                                <option value="">선택하세요</option>
                                                <option value={1}>지사</option>
                                                <option value={2}>총판</option>
                                                <option value={3}>대리점</option>
                                                <option value={4}>영업자1</option>
                                                <option value={5}>영업자2</option>
                                                <option value={6}>영업자3</option>
                                            </select>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>상위에이전트</span>
                                            <select
                                                id="상위에이전트"
                                                name="상위에이전트"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.상위에이전트}
                                                onChange={handleChange}
                                                disabled={formData.에이전트등급 == '1' ? true : false}
                                            >
                                                <option value="">상위에이전트를 선택해주세요.</option>
                                                {
                                                    levelData.map(function (a, i) {
                                                        return (
                                                            <option key={i} value={a.code}>{a.nm}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>에이전트ID</span>
                                            <input
                                                id="에이전트ID"
                                                name="에이전트ID"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.에이전트ID}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>에이전트명</span>
                                            <input
                                                id="에이전트명"
                                                name="에이전트명"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="14"
                                                value={formData.에이전트명}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>에이전트수수료</span>
                                            <input
                                                id="에이전트수수료"
                                                name="에이전트수수료"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="10"
                                                value={formData.에이전트수수료}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>정산은행</span>
                                            <select
                                                id="정산은행"
                                                name="정산은행"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.정산은행}
                                                onChange={handleChange}
                                            >
                                                {
                                                    bank.map((a, i) => (
                                                        <option key={i} value={a.name}>
                                                            {a.name}
                                                        </option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>계좌번호</span>
                                            <input
                                                id="계좌번호"
                                                name="계좌번호"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                value={formData.계좌번호}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>예금주</span>
                                            <input
                                                id="예금주"
                                                name="예금주"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                value={formData.예금주}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>세금계산서 Email</span>
                                            <input
                                                id="세금계산서Email"
                                                name="세금계산서Email"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="13"
                                                value={formData.세금계산서Email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary w-20 reg_btn"
                                onClick={onSubmit}
                                disabled={isSubmitting}
                            >
                                등록
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary w-20 close_btn"
                                onClick={handleCancel}
                                style={{
                                    backgroundColor: "darkred",
                                    marginLeft: "10px",
                                    border: "none"
                                }}
                            >
                                취소
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function UpdateInfo({ setMessage, clickData, setReload }) {
    const MyData = useSelector((state) => state.MyData);

    const initialFormData = {
        에이전트등급: clickData.auth_cd,
        상위에이전트: clickData.parent_code,
        에이전트ID: clickData.agent_id,
        에이전트명: clickData.nm,
        에이전트수수료: Number(clickData.agent_fee),
        정산은행: clickData.bank_nm,
        계좌번호: clickData.accnt_no,
        예금주: clickData.accnt_nm,
        세금계산서Email: clickData.tax_email,
        PG코드: clickData.co_id,
        등록일: clickData.reg_dt,
        수정일: clickData.mod_dt
    }

    const [levelData, setLevelData] = useState([])
    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        setFormData(initialFormData);
        LevelList()
    }, [clickData]);

    const LevelList = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/agent/up-list`, {
            withCredentials: true,
            params: {
                level: clickData.auth_cd
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setLevelData(tmp?.data?.agent ?? [])
            }
            else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // ▼ 중복 클릭 방지용 상태
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        if (window.confirm("수정하시겠습니까?")) {
            try {
                await axios.post(process.env.REACT_APP_API + "/api/agent/update", {
                    id: clickData.id,
                    auth_cd: formData.에이전트등급,
                    agent_id: formData.에이전트ID,
                    nm: formData.에이전트명,
                    agent_fee: formData.에이전트수수료,
                    parent_code: formData.상위에이전트,
                    bank_nm: formData.정산은행,
                    accnt_no: formData.계좌번호,
                    accnt_nm: formData.예금주,
                    tax_email: formData.세금계산서Email,
                    co_id: formData.PG코드
                }, {
                    withCredentials: true,
                }).then((response) => {
                    let tmp = response?.data;
                    if (tmp?.code < 2000) {
                        setMessage({ msg: "에이전트 수정에 성공했습니다." });
                        setReload(e => !e);
                    } else {
                        setMessage({ msg: "에이전트 수정에 실패했습니다." });
                    }
                }).catch(error => {
                    setMessage({ msg: "에이전트 수정에 실패했습니다." });
                    console.error(error);
                });
            } finally {
                setIsSubmitting(false);
            }
        } else {
            setIsSubmitting(false);
        }
    };

    // ▼ 취소 버튼 클릭 시 원래 데이터로 롤백
    const handleCancel = () => {
        setFormData(initialFormData);
    };

    const isDisabled = MyData?.role !== "SUPER";

    return (
        <div style={{ padding: "5px" }}>
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty">
                    <div
                        style={{
                            padding: '0 0 0.5rem',
                            height: "625px",
                            overflowY: "auto",
                            fontSize: "12px",
                            display: 'flex',
                            flexDirection: "column",
                        }}
                    >
                        <div className="list-info-box">
                            <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                <ul>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>PG코드</span>
                                            <input
                                                id="PG코드"
                                                name="PG코드"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.PG코드}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    {
                                        !MyData?.hideElements && (
                                            <li>
                                                <div className="inner" style={{ width: "100%" }}>
                                                    <span className="left-text" style={{ width: "120px", height: "34px" }}>에이전트등급</span>
                                                    <select
                                                        id="에이전트등급"
                                                        name="에이전트등급"
                                                        type="text"
                                                        className="right-text"
                                                        style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                        maxLength="30"
                                                        value={formData.에이전트등급}
                                                        onChange={handleChange}
                                                        disabled
                                                    >
                                                        <option value="">선택하세요</option>
                                                        <option value={1}>지사</option>
                                                        <option value={2}>총판</option>
                                                        <option value={3}>대리점</option>
                                                        <option value={4}>영업자1</option>
                                                        <option value={5}>영업자2</option>
                                                        <option value={6}>영업자3</option>
                                                    </select>
                                                </div>
                                            </li>
                                        )
                                    }
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>상위에이전트</span>
                                            <select
                                                id="상위에이전트"
                                                name="상위에이전트"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.상위에이전트}
                                                onChange={handleChange}
                                                disabled={MyData?.role != "SUPER" ? true : formData.에이전트등급 == '1' ? true : false}
                                            >
                                                <option value="">상위에이전트를 선택해주세요.</option>
                                                {
                                                    levelData.map(function (a, i) {
                                                        const displayName = clickData.agent_id === "fast00160" ? "빠른결제대행사" : a.nm;
                                                        return (
                                                            <option key={i} value={a.code}>{displayName}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>에이전트ID</span>
                                            <input
                                                id="에이전트ID"
                                                name="에이전트ID"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.에이전트ID}
                                                disabled={isDisabled}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>에이전트명</span>
                                            <input
                                                id="에이전트명"
                                                name="에이전트명"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="14"
                                                value={formData.에이전트명}
                                                disabled={isDisabled}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>에이전트수수료</span>
                                            <input
                                                id="에이전트수수료"
                                                name="에이전트수수료"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="10"
                                                value={formData.에이전트수수료}
                                                disabled={isDisabled}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>정산은행</span>
                                            <select
                                                id="정산은행"
                                                name="정산은행"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.정산은행}
                                                disabled={isDisabled}
                                                onChange={handleChange}
                                            >
                                                {
                                                    bank.map((a, i) => (
                                                        <option key={i} value={a.name}>
                                                            {a.name}
                                                        </option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>계좌번호</span>
                                            <input
                                                id="계좌번호"
                                                name="계좌번호"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                value={formData.계좌번호}
                                                disabled={isDisabled}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>예금주</span>
                                            <input
                                                id="예금주"
                                                name="예금주"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                value={formData.예금주}
                                                disabled={isDisabled}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>세금계산서 Email</span>
                                            <input
                                                id="세금계산서Email"
                                                name="세금계산서Email"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="13"
                                                value={formData.세금계산서Email}
                                                disabled={isDisabled}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>등록일</span>
                                            <input
                                                id="등록일"
                                                name="등록일"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="13"
                                                value={formData.등록일}
                                                disabled={true}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>수정일</span>
                                            <input
                                                id="수정일"
                                                name="수정일"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="13"
                                                value={formData.수정일}
                                                disabled={true}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* <form id="modal-form" className="modal-body grid grid-cols-12 gap-4 gap-y-3">
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="에이전트등급" className="form-label">에이전트등급</label>
                                <select
                                    id="에이전트등급"
                                    name="에이전트등급"
                                    type="text"
                                    className="form-control input-padding"
                                    maxLength="30"
                                    value={formData.에이전트등급}
                                    onChange={handleChange}
                                    disabled
                                >
                                    <option value="">선택하세요</option>
                                    <option value={1}>지사</option>
                                    <option value={2}>총판</option>
                                    <option value={3}>대리점</option>
                                </select>
                            </div>

                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="상위에이전트" className="form-label">상위에이전트</label>
                                <select
                                    id="상위에이전트"
                                    name="상위에이전트"
                                    type="text"
                                    className="form-control input-padding"
                                    maxLength="30"
                                    value={formData.상위에이전트}
                                    onChange={handleChange}
                                    disabled={MyData?.role !== "SUPER" ? true : formData.에이전트등급 != '2' && formData.에이전트등급 != '3'}
                                >
                                    <option value="">상위에이전트를 선택해주세요.</option>
                                    {
                                        levelData.map(function (a, i) {
                                            return (
                                                <option key={i} value={a.code}>{a.nm}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="에이전트ID" className="form-label">에이전트ID</label>
                                <input
                                    id="에이전트ID"
                                    name="에이전트ID"
                                    type="text"
                                    className="form-control input-padding"
                                    maxLength="30"
                                    value={formData.에이전트ID}
                                    disabled={isDisabled}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="에이전트명" className="form-label">에이전트명</label>
                                <input
                                    id="에이전트명"
                                    name="에이전트명"
                                    type="text"
                                    className="form-control input-padding"
                                    maxLength="14"
                                    value={formData.에이전트명}
                                    disabled={isDisabled}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="에이전트수수료" className="form-label">에이전트수수료</label>
                                <input
                                    id="에이전트수수료"
                                    name="에이전트수수료"
                                    type="text"
                                    className="form-control input-padding"
                                    maxLength="10"
                                    value={formData.에이전트수수료}
                                    disabled={isDisabled}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-span-12 sm:col-span-6">
                            </div>
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="정산은행" className="form-label">정산은행</label>
                                <select
                                    id="정산은행"
                                    name="정산은행"
                                    type="text"
                                    className="form-control input-padding"
                                    maxLength="30"
                                    value={formData.정산은행}
                                    disabled={isDisabled}
                                    onChange={handleChange}
                                >
                                    {
                                        bank.map((a, i) => (
                                            <option key={i} value={a.name}>
                                                {a.name}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="계좌번호" className="form-label">계좌번호</label>
                                <input
                                    id="계좌번호"
                                    name="계좌번호"
                                    type="text"
                                    className="form-control input-padding"
                                    value={formData.계좌번호}
                                    disabled={isDisabled}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="예금주" className="form-label">예금주</label>
                                <input
                                    id="예금주"
                                    name="예금주"
                                    type="text"
                                    className="form-control input-padding"
                                    value={formData.예금주}
                                    disabled={isDisabled}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="세금계산서Email" className="form-label">세금계산서 Email</label>
                                <input
                                    id="세금계산서Email"
                                    name="세금계산서Email"
                                    type="text"
                                    className="form-control input-padding"
                                    maxLength="13"
                                    value={formData.세금계산서Email}
                                    disabled={isDisabled}
                                    onChange={handleChange}
                                />
                            </div>
                        </form> */}

                        <div className="modal-footer">
                            {
                                MyData?.role == "SUPER"
                                    ?
                                    <>
                                        <button
                                            type="button"
                                            className="btn btn-primary w-20 reg_btn"
                                            onClick={onSubmit}
                                            disabled={isSubmitting}
                                        >
                                            수정
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary w-20 close_btn"
                                            onClick={handleCancel}
                                            style={{ backgroundColor: "darkred", marginLeft: "10px", border: "none" }}
                                        >
                                            취소
                                        </button>
                                    </>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function SubmerchantsList({ setMessage, clickData, setReload }) {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })

    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(20)
    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [combineList, setCombineList] = useState([])

    const [listState, setListState] = useState(false)

    useEffect(() => {
        fetchAgentSubData();
    }, [clickData]);

    const fetchAgentSubData = async () => {
        try {
            const res = await axios.get(process.env.REACT_APP_API + "/api/agent/merchant-list", {
                params: {
                    agentId: clickData.agent_id
                },
                withCredentials: true,
            });
            console.log(res.data);

            if (res.data?.code < 2000) {
                setListData(res?.data?.data?.merchant ?? [])
            } else if (res.data?.code === 9999) {
                navigate("/");
            }
        } catch (err) {
            console.error(err);
            navigate("/");
        }
    };

    const tableHeaderData =
        [
            { "no": 1, "text": "가맹점명", "width": "150px", "textAlign": "center" },
            { "no": 2, "text": "수수료", "width": "80px", "textAlign": "center" },
            { "no": 3, "text": "매출", "width": "100px", "textAlign": "center" },
            // { "no": 4, "text": "상세", "width": "50px", "textAlign": "center" }
        ]

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            setCombineList(listData)
            let list = listData
            for (let i = 0; i < list.length; i++) {
                let data = list[i]

                let rowData = [
                    { "no": 1, "text": data.co_nm, "width": "150px", "textAlign": "left" },
                    { "no": 2, "text": `${Number(data.fee)}%`, "width": "80px", "textAlign": "right" },
                    { "no": 3, "text": changeNum(Number(data.total_amount)), "width": "100px", "textAlign": "right" },
                    // {
                    //     "no": 4,
                    //     "text": (
                    //         <div className='pointer list-text-center' onClick={() => { }}>
                    //             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    //                 viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                    //                 strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-clipboard w-4 h-4"
                    //                 style={{ color: "#0a6e0a" }}>
                    //                 <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    //                 <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                    //             </svg>
                    //         </div>
                    //     ),
                    //     "width": "50px",
                    //     "textAlign": "center"
                    // },
                ]

                rowData.id = data.id
                tableBodyData.push(rowData);
            }
            setListState(e => !e)
            setCombineData(tableBodyData)
        }
    }, [listData, page, maxFirstPage])

    return (
        <div style={{ padding: "5px" }}>
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty">
                    <div
                        style={{
                            padding: '0 0 0.5rem',
                            height: "625px",
                            overflowY: "auto",
                            fontSize: "12px",
                        }}
                    >
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={combineList ?? []}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            // clickData={clickData}
                            // onRowClick={handleRowClick}
                            listType={true}
                            listState={listState}
                            // observerRef={observerRef}
                            nonePage={false}
                            scrollState={true}
                            height={"550px"}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IntegrateAgent